/* T FOR ALL — single-unit sticky header.
   The announcement bar + nav are ONE component (#TfaHeaderStack). At the top it
   overlays the hero and scrolls away with the page. Past a threshold (near the
   end of the hero) a solid version slides in smoothly — no teleport. */
(function () {
  function init() {
    var el = document.getElementById('TfaHeaderStack');
    if (!el) return;
    var hero = document.querySelector('.tfa-hero');
    function threshold() {
      return hero ? Math.max(hero.offsetHeight - 140, 120) : 140;
    }
    var t = threshold();
    var ticking = false;
    function update() {
      if (window.scrollY > t) el.classList.add('is-pinned');
      else el.classList.remove('is-pinned');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', function () { t = threshold(); }, { passive: true });
    update();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
